<div class="job-posts placements agreements  margin-top-30px top-link2" *canUserAccess="['HL_MI_5']">
  <div class="card skillassest-form">

  </div>
  <div class="card-body padding-top padding-left-0px padding-right-10px">
    <div class="row bk-color-sky">
      <div class="col-12 border-right-left-clr text-align-left padding-right-5px my-profile-form padding-left-3px">
        <div class="row margin-left-0px margin-right-0px">
          <label class="col-12 margin-bottom-0px font-weight-bold font-size-20px">Doctor Appointments</label>
        </div>

      </div>
      <div class="col-12 border-right-left-clr text-align-center padding-right-5px my-profile-form padding-left-3px">
        <div class="row">
          <!--<label class="col-md-2 col-2 margin-bottom-0px  font-size-12px color-Assign">Branch</label>-->
          <div class="my-profile-form col-md-10 col-10">

            <select class="form-control padding-left-0px padding-right-0px" (change)="onDocChange($event.target.value)" [(ngModel)]="value">
              <option selected="selected" value=""></option>
              <option *ngFor="let l of CurrentDoctorsListController" [value]="l.ProviderCode">
                {{l.Prefix}}{{l.DisplayName}}
              </option>
            </select>
          </div>

        </div>
        <!--<div class="row" hidden>
         
          <div class="my-profile-form col-md-10 col-10">


            <CustomDataByRequestType RequestedType="FacilityList" class="form-group Strawfont" ActorCode={{ActorCode}}
                                     (keyChange)="Roleassign($event)"
                                     [(ngModel)]="SelectedFacilityCode" name="SelectedFacilityCode" SelectedValue="SelectedFacilityCode"
                                     required>
            </CustomDataByRequestType>
          </div>

        </div>-->

      </div>

      <div class="col-12 border-right-left-clr text-align-center padding-right-5px my-profile-form padding-left-3px border-bot-2px">
        <div class="form-group  margin-bottom-5px">
          <div class="row">
            <div class="col-2 margin-top-auto margin-bottom-auto padding-left-6px padding-right-19px decrementhover" (click)="DecrementDate()">
              <a title="Previous" class="nav-link-hand">
                <i class="fas fa-caret-left margin-top-3px  font-size-24px"></i>
              </a>
            </div>


            <div class="col-8 padding-l-0px padding-right-9px">
              <div class="date-form">
                <input class="form-control text-align-center border-top-0 border-left-0 border-right-0 border-bottom-0px border-radius-2px font-size-24px data-color-new" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                       name="SelectedFromDate" [(ngModel)]="SelectedFromDate" ngbDatepicker #d="ngbDatepicker"
                       (ngModelChange)="dataChanged($event)">

                <a (click)="d.toggle()" class="nav-link-hand">
                  <span class="date-icon font-size-16px"><i class="far fa-calendar-alt data-color-new"></i></span>

                </a>

              </div>



            </div>
            <div class="col-2  margin-top-auto margin-bottom-auto padding-left-6px padding-right-19px decrementhover" (click)="IncrementDate()">
              <a title="Next" class="nav-link-hand">
                <i class="fas fa-caret-right margin-top-3px  font-size-24px "></i>
              </a>
            </div>

          </div>

        </div>
      </div>

      <div class="col-12 padding-right-5px my-profile-form padding-left-3px border-bot-2px" hidden>
        <div class="row margin-left-0px margin-right-0px">
          <div class="col-6 text-align-left" *ngIf="selectedDoc">
            <label class="margin-bottom-0px font-size-14 color-blue">{{selectedDoc.DisplayName}}</label>
          </div>
          <div class="col-6 text-align-right">
            <label class="margin-bottom-0px font-size-14">{{DateSelected| date:'dd-MMM-yyyy'}}</label>
          </div>

        </div>

      </div>

      <div class="col-12 my-profile-form padding-left-3px padding-right-0px">

        <div class="table-component b1 margin-bottom-0px" >
          <div class="table-responsive overflow-x">


            <table class="table table-striped margin-left-zero width-100pe"
                   cols="auto,*,auto">

              <tbody class="table-body">

                <tr class="margin-all-5px" *ngFor="let l of CurrentDoctorAppointmentsByDoctorcodeController">

                  <td class="padding-right-0px padding-top-0px padding-bottom-0px padding-left-10px"
                   >
                    <div [ngSwitch]="l.AppointmentStatus">
                      <div *ngSwitchCase="'Pending'" class="td-border-8px-gray">
                        <label>  </label>
                      </div>
                      <div *ngSwitchCase="'Completed'" class="td-border-8px-green">
                        <label>  </label>
                      </div>
                      <div *ngSwitchCase="'Cancelled'" class="td-border-8px-red">
                        <label>  </label>
                      </div>
                      <div *ngSwitchDefault class="td-border-8px-Black">
                        <label>  </label>
                      </div>
                    </div>
                  </td>
                  <td class="padding-top-0px padding-bottom-0px" >
                    <div class="row margin-left-0px margin-right-0px">
                      <div class="col-12 margin-top-5px margin-bottom-5px  padding-left-7px padding-right-0px">

                        <div class="row margin-left-0px margin-right-0px">
                          <div class="col-3 padding-right-0px padding-left-0px">
                            <div class="row margin-left-0px margin-right-0px">

                              <img class="user-image-circle-65px img-60px" [src]="l.PatientImageFile" onError="this.src='dummy.jpg';">

                            </div>

                          </div>
                          <div class="col-9 padding-left-0px padding-right-0px">
                            <div class="row padding-all-0px">
                              <div class="col-8">
                                <div class="row ">
                                  <div class="col-12 padding-right-0px">
                                    <label class="margin-bottom-0px font-size-16px font-weight-600 td-elipsis-appoinment margin-top-3px display-inline">{{l.PatientName}}</label>

                                  </div>

                                </div>
                                <div class="row a1">


                                  <label class="margin-bottom-0px font-size-12px">{{l.Gender}} ,</label>
                                  <label class="margin-bottom-0px font-size-12px  display-inline"> {{l.Age}}</label>

                                </div>
                                <div class="row a1">

                                  <label class="margin-bottom-0px f3"><i class="fas fa-phone"></i> {{l.Telephone1}} </label>



                                </div>
                                <div class="row a1" *ngIf="l.IsRegistered == 1">
                                  <label class="margin-bottom-0px font-size-12px
                                         td-elipsis-appoinment  color-Assign font-weight-bold">{{l.PatientFormattedCode}}
                                  </label>
                                </div>
                                <div class="row a1" *ngIf="l.IsRegistered == 1">
                                  <label class="margin-bottom-0px font-size-12px  td-elipsis-appoinment  color-Assign font-weight-bold">{{l.FacilityName}}</label>
                                </div>
                            
                              </div>
                              <div class="col-4 padding-left-0px">
                                <div class="col-12 padding-right-0px text-align-right">
                                  <label class="margin-bottom-0px font-size-16px">{{l.AppointmentDate | date: 'hh:mm a'}}</label>
                                </div>
                              </div>

                            </div>
                          </div>

                          <!--<div class="col-md-1 padding-right-0px padding-top-6pe test-icons">



            <div class="row float-right">

              <button type="button" (click)="cancel()" class="btn btn-secondary font-size-10px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-5px float-right padding-top-1px padding-bottom-1px padding-left-2px padding-right-2px"><i class="fa fa-times color-Rejected margin-right-3px"></i>Cancel</button>
            </div>
          </div>-->

                        </div>


                      </div>
                    </div>
                  </td>
                  <!--<td class="padding-top-0px padding-bottom-0px" *ngIf="l.FacilityName == SelectedFacilityName">
                    <div class="col-12 padding-right-0px">
                      <label class="margin-bottom-0px font-size-12px">{{l.AppointmentDate | date: 'hh:mm a'}}</label>
                    </div>
                  </td>-->
                </tr>

              </tbody>

            </table>
          </div>
        </div>

      </div>

    </div>
    `
  </div>

</div>




